'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ObjectHelper = require('../../common/ObjectHelper.js');

var componentForm = {
  street_number: 'short_name',
  // street_number
  route: 'short_name',
  // street name
  locality: 'long_name',
  // city
  sublocality_level_1: 'long_name',
  //alternate city
  neighborhood: 'long_name',
  //alternate city
  administrative_area_level_1: 'short_name',
  // state
  country: 'short_name',
  // country
  postal_code: 'short_name' // postalCode

};
function parseGoogleAddress(selectedPlace) {
  if (ObjectHelper.isBlank(selectedPlace)) {
    return;
  }

  var selectedSuggest = {};
  selectedPlace.address_components.forEach(function (addressComponent) {
    var addressType = addressComponent.types[0];

    if (componentForm[addressType]) {
      selectedSuggest[addressType] = addressComponent[componentForm[addressType]];
    }
  });
  var streetName = '';

  if (selectedSuggest.street_number) {
    streetName = streetName.concat(selectedSuggest.street_number);
  }

  if (selectedSuggest.route) {
    streetName = streetName.concat(' ', selectedSuggest.route);
  }

  if (!selectedSuggest.locality) {
    selectedPlace.address_components.forEach(function (addressComponent) {
      addressComponent.types.map(function (type) {
        if (type == 'sublocality_level_1') {
          selectedSuggest[type] = addressComponent[componentForm[type]];
        }

        if (type == 'neighborhood') {
          selectedSuggest[type] = addressComponent[componentForm[type]];
        }
      });
    });
  }

  var callbackObject = {
    name: selectedPlace.name,
    street: streetName,
    city: selectedSuggest.locality || selectedSuggest.sublocality_level_1 || selectedSuggest.neighborhood,
    state: selectedSuggest.administrative_area_level_1,
    postal_code: selectedSuggest.postal_code,
    country: selectedSuggest.country,
    latitude: selectedPlace.geometry.location.lat(),
    longitude: selectedPlace.geometry.location.lng(),
    formatted_address: selectedPlace.formatted_address,
    placeId: selectedPlace.place_id
  };
  return callbackObject;
}

exports.parseGoogleAddress = parseGoogleAddress;
